import { navEntries } from '@/mocks/home';

const ENTRY_TARGET: Record<string, string> = {
  person: '#index',
  event: '#events',
  collections: '#collections',
  source: '#archive',
  daily: '#feed',
  archive: '#download',
};

export default function NavEntries() {
  return (
    <section id="entries" className="w-full px-4 md:px-8 py-12 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-background-300 pb-5">
        <div>
          <span className="text-xs font-label tracking-[0.3em] text-primary-600">02 / 导航入口</span>
          <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">从这里进入</h3>
        </div>
        <p className="max-w-md text-sm leading-6 text-foreground-600">
          六个入口覆盖查人、查事、查合集与下载，看完快讯直接点一下就能进去。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {navEntries.map((entry) => {
          const highlight = entry.id === 'archive';
          return (
            <a
              key={entry.id}
              href={ENTRY_TARGET[entry.id] ?? '#entries'}
              className={[
                'group rounded-lg p-5 transition-colors cursor-pointer',
                highlight
                  ? 'bg-primary-500 hover:bg-primary-600'
                  : 'border border-background-300 bg-background-50 hover:border-primary-300 hover:bg-background-100',
              ].join(' ')}
            >
              <div className="flex items-start justify-between gap-3">
                <span
                  className={[
                    'w-11 h-11 flex items-center justify-center rounded-md',
                    highlight ? 'bg-primary-950/25 text-background-50' : 'bg-accent-100 text-accent-800',
                  ].join(' ')}
                >
                  <i className={`${entry.icon} text-xl`} />
                </span>
                <span
                  className={[
                    'rounded-full px-2.5 py-0.5 text-[11px] font-label',
                    highlight ? 'bg-background-50/20 text-background-50' : 'bg-secondary-100 text-secondary-900',
                  ].join(' ')}
                >
                  {entry.badge}
                </span>
              </div>
              <h4
                className={[
                  'mt-4 font-heading text-lg md:text-xl font-bold',
                  highlight ? 'text-background-50' : 'text-foreground-950',
                ].join(' ')}
              >
                {entry.title}
              </h4>
              <p
                className={[
                  'mt-2 text-sm leading-6',
                  highlight ? 'text-background-100/90' : 'text-foreground-600',
                ].join(' ')}
              >
                {entry.desc}
              </p>
              <div className="mt-5 flex items-center justify-between">
                <span
                  className={[
                    'text-xs font-label tracking-wide',
                    highlight ? 'text-background-100/90' : 'text-foreground-500',
                  ].join(' ')}
                >
                  {entry.count}
                </span>
                <span
                  className={[
                    'inline-flex items-center gap-1 text-xs font-label transition-transform group-hover:translate-x-0.5',
                    highlight ? 'text-background-50' : 'text-primary-600',
                  ].join(' ')}
                >
                  进入
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}